import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { TextButton } from '@bibliocommons/base-buttons';
import { FlagOutline } from '@bibliocommons/base-icons';
import ModalContainer from 'app/components/shared/Modal/ModalContainer';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import FlagUgcFormContainer from './FlagUgcForm';

import './FlagUgcButton.scss';

export default class FlagUgcButton extends React.PureComponent {
  modalKey = `flag-ugc-${this.props.id}`;

  openModal = () => this.props.modalActions.openModal(this.modalKey);

  closeModal = () => this.props.modalActions.closeModal(this.modalKey);

  render() {
    const { id } = this.props;

    return (
      <div className="cp-flag-ugc-button">
        <TextButton
          handleClick={this.openModal}
          className="ugc-display__flag-button"
          dataKey="flag-ugc-button"
          size="small"
          renderLeadingIcon={() => <FlagOutline />}
        >
          <span aria-hidden>
            <FormattedMessage id="flag" />
          </span>
          <ScreenReaderMessage>
            <FormattedMessage id="sr_flag" values={{ ugcType: this.props.ugcType }} />
          </ScreenReaderMessage>
        </TextButton>

        <ModalContainer modalKey={this.modalKey} handleClose={this.closeModal}>
          <FlagUgcFormContainer id={id} handleClose={this.closeModal} />
        </ModalContainer>
      </div>
    );
  }
}

FlagUgcButton.propTypes = {
  id: PropTypes.number.isRequired,
  ugcType: PropTypes.string.isRequired,
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired
};
